import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { usePipeline } from '../PipelineContext';

const GATE_INFO = {
  what: 'A pause point in the pipeline. Work stops here until a human approves, rejects, or a rule auto-passes the flow.',
  examples: ['Content approval before posts go live on Instagram', 'Budget sign-off before a campaign launches'],
};

export default function GateNode({ id, data, selected }) {
  const [showInfo, setShowInfo] = useState(false);
  const { showTokens, tokenData, fmtTokens, fmtCost, opsMode } = usePipeline() || {};
  const nodeTokens   = tokenData?.[id];
  const headerStyle  = data.color ? { background: data.color + '22', color: data.color } : {};
  const nodeStyle    = data.color ? { borderColor: data.color } : {};
  const pendingCount = data.pendingApprovals?.length || 0;

  return (
    <div className={`pipeline-node gate-node ${selected ? 'selected' : ''}`} style={nodeStyle}>
      <Handle type="target" position={Position.Left}  className="node-handle" />

      <div className="node-header gate-header" style={headerStyle}>
        <span className="node-type-icon">{opsMode ? '✅' : '◆'}</span>
        <span className="node-type-label">{opsMode ? 'Approval' : 'Gate'}</span>
        {pendingCount > 0 && (
          <span className="gate-pending-badge" title={`${pendingCount} pending approval${pendingCount !== 1 ? 's' : ''}`}>{pendingCount}</span>
        )}
        <button className="node-info-btn" onMouseDown={e => e.stopPropagation()} onClick={e => { e.stopPropagation(); setShowInfo(s => !s); }}>ⓘ</button>
        {showTokens && nodeTokens && (
          <span className="token-total-badge">{opsMode ? fmtCost?.(nodeTokens.total) : `${fmtTokens(nodeTokens.total)} tok`}</span>
        )}
      </div>

      <div className="node-body">
        <div className="node-title">{data.label}</div>
        {data.description && <div className="node-description">{data.description}</div>}
        {showInfo && (
          <div className="node-info-card">
            <div className="node-info-what">{GATE_INFO.what}</div>
            <div className="node-info-eg-label">Examples:</div>
            {GATE_INFO.examples.map((ex, i) => <div key={i} className="node-info-eg">→ {ex}</div>)}
          </div>
        )}
        <div className="gate-node-badge" style={data.color ? { background: data.color + '22', color: data.color } : {}}>
          {pendingCount > 0 ? `${pendingCount} awaiting review` : (opsMode ? 'Sign-off required' : 'Approval required')}
        </div>
      </div>

      <Handle type="source" position={Position.Right} className="node-handle" />
    </div>
  );
}
